import SelectApiClientType from '@/api/SelectApiClientType'

// A page title or breadcrumb needs the name of one record. The users list is far too large to load
// whole for that (tens of thousands of rows), so it is asked for by id; the other lists are small.
export const selectQueryForId = (selectType, id) =>
    selectType === SelectApiClientType.USER && id
        ? { query: { ids: String(id) } }
        : undefined
